<template>
    <div class="thank-you-box">
        <router-link style="text-decoration: none;" to="/">
            <v-icon class="close-message-button" color="white" dark x-large>mdi-close</v-icon>
        </router-link>
        <div class="message">
            <h2>Thank You</h2>
            <p>We'll be in touch shortly!</p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.thank-you-box{
    display: grid;
    background-color: #E4AF79;
    position: relative;
    width: clamp(40vw, 1000px, 60vw);
    height: calc(300px + 10vw);
    border-radius: 25px;
    // text-align: center;

    .message{
        // position: absolute;
        color: white;
        font-family: Poppins;
        font-style: normal;
        font-size: 2vw;
        text-align: center;
    }

    .close-message-button{
        top: 1vw;
        right: 1vw;
        // z-index: 1000;
        position: absolute;
    }
}
</style>
